module.exports = __webpack_public_path__ + "static/media/female-voice.7e5e8c30.svg";